
import clientAuth from "../clientAuth"
export default {
    Newbooking: () => clientAuth.get(`notification/new/booking`),
    Newvoucher: () => clientAuth.get(`notification/new/voucher`),
    Newinquiry: () => clientAuth.get(`notification/new/inquiry`),
    Newnewsletter: () => clientAuth.get(`notification/new/newsletter`),
    Newnuserregister: () => clientAuth.get(`notification/new/user/register`),
    Newtripplan: () => clientAuth.get(`notification/new/tripplan`),
    // NewDocument: () => clientAuth.get(`notification/new/user/document`),
    NewDatabase: () => clientAuth.get(`notification/new/customer/database`),
    // MarkAsRead: (type) => clientAuth.post(`notification/mark-as-read`,{ json: type }),  

};